import { Component } from '@angular/core';

@Component({
    selector: 'wdx-ff-version-info',
    templateUrl: './form-version-info.component.html',
    standalone: false,
    host: { class: 'd-block w-100' },
})
export class FormVersionInfoComponent {}
